// extracted by mini-css-extract-plugin
export default {"gblHeaderDialogItem":"GlobalDialog_gblHeaderDialogItem__qhqHc","dialogClassName":"GlobalDialog_dialogClassName__DANL9"};